import { Gift as GiftIcon, User } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const Opt = ({ active, onClick, icon: Icon, title, desc, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`flex flex-1 items-start gap-3 border p-4 text-left transition-colors ${active ? "border-stone-900 bg-white" : "border-[#E6DEC8] hover:border-stone-400"}`}>
    <Icon className={`mt-0.5 h-4 w-4 ${active ? "text-[#B8860B]" : "text-stone-400"}`} />
    <span><span className="block text-sm font-semibold">{title}</span><span className="mt-1 block text-xs text-stone-500">{desc}</span></span>
  </button>
);

export const GiftToggle = ({ s, set }) => (
  <div>
    <Label className="text-sm font-medium text-stone-800">Who is this report for?</Label>
    <div className="mt-2 flex flex-col gap-3 sm:flex-row" data-testid="gift-toggle">
      <Opt active={!s.isGift} onClick={() => set({ isGift: false })} icon={User} title="Myself" desc="The report is emailed to you." testId="gift-toggle-self" />
      <Opt active={s.isGift} onClick={() => set({ isGift: true })} icon={GiftIcon} title="Someone else — a gift" desc="Enter their name; we email the report to them." testId="gift-toggle-gift" />
    </div>
  </div>
);

export const giftValid = (s) => !s.isGift || (/\S+@\S+\.\S+/.test(s.recipientEmail) && s.recipientEmail.toLowerCase() === s.recipientEmail2.toLowerCase() && s.giftFrom.trim());

export function GiftFields({ s, set }) {
  const match = s.recipientEmail && s.recipientEmail.toLowerCase() === s.recipientEmail2.toLowerCase();
  return (
    <div className="space-y-6 border-l-2 border-[#B8860B] pl-5" data-testid="gift-fields">
      <p className="font-serif-display text-2xl italic text-[#5B2C36]">A gift, thoughtfully delivered</p>
      <div>
        <Label className="text-sm font-medium text-stone-800">Recipient's email address *</Label>
        <Input type="email" value={s.recipientEmail} onChange={(e) => set({ recipientEmail: e.target.value })} className="mt-2 h-12 bg-white" data-testid="gift-recipient-email-input" />
      </div>
      <div>
        <Label className="text-sm font-medium text-stone-800">Confirm recipient's email *</Label>
        <Input type="email" value={s.recipientEmail2} onChange={(e) => set({ recipientEmail2: e.target.value })} onPaste={(e) => e.preventDefault()} className="mt-2 h-12 bg-white" data-testid="gift-recipient-email-confirm-input" />
        {s.recipientEmail2 && <p className={`mt-2 text-xs ${match ? "text-emerald-700" : "text-[#5B2C36]"}`} data-testid="gift-email-match-indicator">{match ? "Email addresses match" : "Email addresses do not match"}</p>}
      </div>
      <div>
        <Label className="text-sm font-medium text-stone-800">From (your name, as it should appear) *</Label>
        <Input value={s.giftFrom} maxLength={80} onChange={(e) => set({ giftFrom: e.target.value })} className="mt-2 h-12 bg-white" data-testid="gift-from-input" />
      </div>
      <div>
        <Label className="text-sm font-medium text-stone-800">Personal message (optional)</Label>
        <Textarea value={s.giftMessage} maxLength={300} rows={3} onChange={(e) => set({ giftMessage: e.target.value })} className="mt-2 bg-white" data-testid="gift-message-input" />
        <p className="mt-1 text-right text-xs text-stone-400">{s.giftMessage.length}/300 · shown on the report cover and in the gift email</p>
      </div>
    </div>
  );
}
